"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const regist_1 = require("../../../redux/regist");
const actionTypes_1 = require("./actionTypes");
const initialState = {
    token: {
        access_token: undefined,
        refresh_token: undefined,
    },
    user: undefined,
    isTeacher: false,
    manager: [],
    isAdmin: false,
};
regist_1.ReducerRegistry.register('base/account', (state = initialState, action) => {
    switch (action.type) {
        case actionTypes_1.SET_TOKEN:
            return {
                ...state,
                token: action.token,
            };
        case actionTypes_1.SET_USER_INFO:
            return {
                ...state,
                user: action.user,
                isTeacher: action.isTeacher,
            };
        case actionTypes_1.SET_IS_TEACHER:
            return {
                ...state,
                isTeacher: action.isTeacher,
            };
        case actionTypes_1.SET_MANAGER:
            return {
                ...state,
                manager: action.manager,
            };
    }
    return state;
});
